import { render, staticRenderFns } from "./VisorImagenesECE.vue?vue&type=template&id=2c0d690c&scoped=true"
import script from "./VisorImagenesECE.vue?vue&type=script&lang=js"
export * from "./VisorImagenesECE.vue?vue&type=script&lang=js"
import style0 from "./VisorImagenesECE.vue?vue&type=style&index=0&id=2c0d690c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d690c",
  null
  
)

export default component.exports